import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=7f94eb33&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f94eb33')) {
      api.createRecord('7f94eb33', component.options)
    } else {
      api.reload('7f94eb33', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=7f94eb33&", function () {
      api.rerender('7f94eb33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/login/ForgotPassword.vue"
export default component.exports